import * as React from "react";

const AddPartIconSVG = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
        <path
            fill="#171718"
            d="M19 25h2v-4h4v-2h-4v-4h-2v4h-4v2h4zm1 5a9.7 9.7 0 0 1-3.9-.788 10.1 10.1 0 0 1-3.175-2.137q-1.35-1.35-2.137-3.175A9.7 9.7 0 0 1 10 20q0-2.075.788-3.9a10.1 10.1 0 0 1 2.137-3.175q1.35-1.35 3.175-2.137A9.7 9.7 0 0 1 20 10q2.075 0 3.9.788a10.1 10.1 0 0 1 3.175 2.137q1.35 1.35 2.137 3.175A9.7 9.7 0 0 1 30 20a9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.137A9.7 9.7 0 0 1 20 30m0-2q3.35 0 5.675-2.325T28 20t-2.325-5.675T20 12t-5.675 2.325T12 20t2.325 5.675T20 28"
        ></path>
    </svg>
);

export default AddPartIconSVG;
